import React from 'react';
import { RecommendationBar } from '../../../components/Shared';
import { PaintingCiting } from '../../../components/citing/PaintingCiting';
import { ContributorSection } from '../../../components/ContributorSection';
import { MoreOptionsSection } from '../../../components/MoreOptions';
import GenericSection from '../../../components/GenericSection';
import SEEN_PUBINFO_SECTION_FIELDS from '../constants/fieldList/Seen';
import { PaintingContributorRoleOptions, TabHeaders } from '../constants';
var Seen = function Seen() {
  var SEEN_SECTION_TEST_ID = 'seen-pub-section-test-id';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RecommendationBar, null), /*#__PURE__*/React.createElement(PaintingCiting, {
    selectedTab: TabHeaders.SEEN
  }), /*#__PURE__*/React.createElement(ContributorSection, {
    functionOptions: PaintingContributorRoleOptions
  }), /*#__PURE__*/React.createElement(GenericSection, {
    name: "painting",
    sectionTitle: "Media publication info",
    fieldList: SEEN_PUBINFO_SECTION_FIELDS,
    "data-test": SEEN_SECTION_TEST_ID,
    selectedTab: TabHeaders.SEEN
  }), /*#__PURE__*/React.createElement(MoreOptionsSection, null));
};
export default Seen;